import { render } from "./play-list.vue?vue&type=template&id=8171df6a&ts=true"
import script from "./play-list.vue?vue&type=script&lang=ts"
export * from "./play-list.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__